<template>
  <div>
  </div>
</template>

<script>
export default {
  name: 'StripePaynow',
  data() {
    return {
      invalid: false,
      error: '',
    };
  },
  mounted() {
    this.$emit('update:invalid', this.invalid);
  },
  beforeDestroy() {
  },
  props: [
    'amount',
  ],
};
</script>

<style scoped>
</style>
